export const getLocalidadOptions = (state) => {
   const allLocalidades = Object.values(state?.localidades || {})
      .filter(Array.isArray)
      .flat();

   return allLocalidades.map((localidad) => ({
      ...localidad,
      label: localidad.descripcion,
      value: localidad.id_localidad,
   }));
};

export const getProvinciasOptions = (state) => {
   const opciones = state?.provincias?.map((provincia) => ({
      ...provincia,
      label: provincia.nombre,
      value: provincia.id_provincia,
   }));
   return opciones;
};

export const getAllStates = (state) => {
   const allStates = Object.keys(state);
   return allStates.map((e) => ({ key: e.toUpperCase(), value: e }));
};

export const getCultivos = (state) => {
   return state.cultivos;
};
